// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ConfirmationAlert_modalWrapper__sfzo7"};